/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CampaignCreateRequest } from '../models/CampaignCreateRequest';
import type { CampaignEditRequest } from '../models/CampaignEditRequest';
import type { CampaignListResponse } from '../models/CampaignListResponse';
import type { CampaignResponse } from '../models/CampaignResponse';
import type { CampaignStatsResponse } from '../models/CampaignStatsResponse';
import type { CampaignUpdateRequest } from '../models/CampaignUpdateRequest';
import type { ManualTaskCreateRequest } from '../models/ManualTaskCreateRequest';
import type { RuleCodeResponse } from '../models/RuleCodeResponse';
import type { TaskResponse } from '../models/TaskResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CampaignsService {
    /**
     * Get available campaign rule codes
     * Get list of available campaign rule codes with descriptions (for campaign creation dropdown)
     * @returns RuleCodeResponse Successful Response
     * @throws ApiError
     */
    public static getRuleCodesApiCampaignsRuleCodesGet({
        xServiceToken,
        xApiKey,
        session,
    }: {
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<Array<RuleCodeResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaigns/rule-codes',
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            errors: {
                400: `Validation error`,
                404: `Campaign not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Create new campaign
     * Create a new campaign in draft status (rule_code validation deferred to Worker)
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static createCampaignApiCampaignsPost({
        requestBody,
        xServiceToken,
        xApiKey,
        session,
    }: {
        requestBody: CampaignCreateRequest,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/campaigns',
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `Campaign not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List campaigns
     * Get paginated list of campaigns with optional status filtering
     * @returns CampaignListResponse Successful Response
     * @throws ApiError
     */
    public static listCampaignsApiCampaignsGet({
        status,
        offset,
        limit = 20,
        xServiceToken,
        xApiKey,
        session,
    }: {
        /**
         * Filter by campaign status
         */
        status?: (string | null),
        /**
         * Pagination offset
         */
        offset?: number,
        /**
         * Maximum number of campaigns to return
         */
        limit?: number,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<CampaignListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaigns',
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            query: {
                'status': status,
                'offset': offset,
                'limit': limit,
            },
            errors: {
                400: `Validation error`,
                404: `Campaign not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get active campaigns
     * Get all campaigns with active status (for Worker usage)
     * @returns CampaignListResponse Successful Response
     * @throws ApiError
     */
    public static getActiveCampaignsApiCampaignsActiveGet({
        xServiceToken,
        xApiKey,
        session,
    }: {
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<CampaignListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaigns/active',
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            errors: {
                400: `Validation error`,
                404: `Campaign not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get campaign statistics
     * Get task counts and success rate for a campaign
     * @returns CampaignStatsResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignStatsApiCampaignsCampaignIdStatsGet({
        campaignId,
        xServiceToken,
        xApiKey,
        session,
    }: {
        campaignId: string,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<CampaignStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaigns/{campaign_id}/stats',
            path: {
                'campaign_id': campaignId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            errors: {
                400: `Validation error`,
                404: `Campaign not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get campaign details
     * Get complete campaign information including error field
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignApiCampaignsCampaignIdGet({
        campaignId,
        xServiceToken,
        xApiKey,
        session,
    }: {
        campaignId: string,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            errors: {
                400: `Validation error`,
                404: `Campaign not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Edit campaign details
     * Edit campaign details (title, rule_code, message_template, etc.). Only draft campaigns can be edited.
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static editCampaignApiCampaignsCampaignIdPut({
        campaignId,
        requestBody,
        xServiceToken,
        xApiKey,
        session,
    }: {
        campaignId: string,
        requestBody: CampaignEditRequest,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `Campaign not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update campaign status
     * Update campaign status, finished_at, and error (primarily for Worker usage)
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static updateCampaignStatusApiCampaignsCampaignIdPatch({
        campaignId,
        requestBody,
        xServiceToken,
        xApiKey,
        session,
    }: {
        campaignId: string,
        requestBody: CampaignUpdateRequest,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `Campaign not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Delete campaign
     * Delete a draft campaign (only draft campaigns can be deleted)
     * @returns void
     * @throws ApiError
     */
    public static deleteCampaignApiCampaignsCampaignIdDelete({
        campaignId,
        xServiceToken,
        xApiKey,
        session,
    }: {
        campaignId: string,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            errors: {
                400: `Validation error`,
                404: `Campaign not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Activate campaign
     * Activate a draft campaign (changes status from draft to active)
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static activateCampaignApiCampaignsCampaignIdActivatePost({
        campaignId,
        xServiceToken,
        xApiKey,
        session,
    }: {
        campaignId: string,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/campaigns/{campaign_id}/activate',
            path: {
                'campaign_id': campaignId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            errors: {
                400: `Validation error`,
                404: `Campaign not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Cancel campaign
     * Cancel a campaign (changes status to cancelled)
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static cancelCampaignApiCampaignsCampaignIdCancelPost({
        campaignId,
        xServiceToken,
        xApiKey,
        session,
    }: {
        campaignId: string,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/campaigns/{campaign_id}/cancel',
            path: {
                'campaign_id': campaignId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            errors: {
                400: `Validation error`,
                404: `Campaign not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Create manual task for campaign
     * Create individual campaign task for specific user (CRM operator usage)
     * @returns TaskResponse Successful Response
     * @throws ApiError
     */
    public static createManualTaskApiCampaignsCampaignIdTasksPost({
        campaignId,
        requestBody,
        xServiceToken,
        xApiKey,
        session,
    }: {
        campaignId: string,
        requestBody: ManualTaskCreateRequest,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<TaskResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/campaigns/{campaign_id}/tasks',
            path: {
                'campaign_id': campaignId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `Campaign not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
}
